import './App.css';
import AppRoutes from './AppRoutes';
import { Theme } from './theme';

function App() {
  return (
    <AppRoutes />
  )
}

export default App;
